module.exports = __webpack_public_path__ + "media/images/version_merge/tree_coins-be90e1a24bfe5cc9b96e4c5356163eef.png";